export default errors => !!(errors === null || errors === void 0 ? void 0 : errors.forbidden) && Object.keys(errors).length === 1;
//# sourceMappingURL=is-forbidden.js.map